import { Link } from 'react-router-dom'
import styles from './DeliveringSolutions.module.css'

const DeliveringSolutions = () => {
  return (
    <section className={styles.deliveringSolutions}>
      <div className={styles.container}>
        <div className={styles.textSection}>
          <h2 className={styles.title}>Delivering Superior HVAC Solutions</h2>
          <p className={styles.subtitle}>
            Ensuring customer satisfaction through quality workmanship
          </p>
        </div>
        <div className={styles.ctaSection}>
          <Link to="/our-services" className={styles.readMoreBtn}>
            Read More
          </Link>
        </div>
      </div>
    </section>
  )
}

export default DeliveringSolutions
